import { ENDPOINT } from "../utils/constants";
import { getServerUrl, oAuthRequest } from "../utils/request";

export const getAssetDuration = (assetId,assetType) =>{

    const serviceBaseAddress = getServerUrl();

    let methodUrl = ""

    switch (assetType){
        case "learningPath":{
            methodUrl = "learning-path";
            break;
        }
        case "learningPathStep":{
            methodUrl = "learning-path-step";
            break;
        }
        case "course": {
            methodUrl = "course";
            break;
        }
        default: {
            methodUrl = "";
            break;
        }
    }

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.MENU}/${methodUrl}/${assetId}/breakdown`,
        method:'get',
    });

}
